import { Component, OnInit } from '@angular/core';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { takeUntil, filter } from 'rxjs/operators';
import { unavailableDayMultipleFormConfig } from '../unavailable-multiple-days/unavailable-multiple-days.component';

@Component({
	selector: 'rpshared-unavailable-multiple-day-dialog',
	templateUrl: './unavailable-multiple-day-dialog.component.html',
	styleUrls: ['./unavailable-multiple-day-dialog.component.scss'],
})
export class UnavailableMultipleDayDialogComponent extends SelfDestruct
	implements OnInit {
	control = new FormControl('') as FormControl;

	group = this.fb.group(unavailableDayMultipleFormConfig) as FormGroup;

	constructor(private readonly fb: FormBuilder) {
		super();
	}

	ngOnInit() {
		this.control.valueChanges
			.pipe(filter(Boolean), takeUntil(this.destroyed))
			.subscribe((v) => this.group.setValue(v));
	}
}
